import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";

const GoBack = ({ to, label, className = "", wrapperClassName = "" }) => {
  return (
      <Link
        to={to}
        className={`inline-flex items-center pl-2 pr-4 py-2 justify-center h-8 border border-gray-300 rounded-lg 
                   font-semibold text-xs leading-4 text-gray-800 hover:text-gray-800 hover:bg-primary/10 hover:shadow-md transition-all duration-300
                   focus:outline-none focus:border-gray-300 active:outline-none ${className}`}
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          className="mr-1"
        >
          <path d="M13 8.39999L9.4 12L13 15.6" stroke="currentColor"/>
        </svg>
        <FormattedMessage id={label} />
      </Link>
  );
};

export default GoBack;
